import { ComponentType, useEffect, useMemo, useState } from 'react';
import dynamic, { Loader } from 'next/dynamic';

export type LoadFunc = () => Loader;

export type DynamicComponentResult<P> = [ComponentType<P>, boolean];

export interface UseDynamicComponentOpts {
  onStart?: () => void;
  onDone?: () => void;
}

export function useDynamicComponent<P>(
  load: LoadFunc,
  { onStart, onDone }: UseDynamicComponentOpts = {}
): DynamicComponentResult<P> {
  const [started, setStarted] = useState<boolean>(false);
  const [done, setDone] = useState<boolean>(false);

  const component = useMemo(() => {
    return dynamic(async () => {
      setStarted(true);
      const c = await load();
      setDone(true);
      return c as ComponentType<P>;
    });
  }, [load, setDone]);

  useEffect(() => {
    if (started) {
      onStart?.();
    }
  }, [started, onStart]);

  useEffect(() => {
    if (done) {
      onDone?.();
    }
  }, [done, onDone]);

  return [component, done];
}
